import { getMaintenanceStatus, type GetMaintenanceStatusOptions, type MaintenanceState } from './maintenanceClient';

export const defaultInitialMaintenanceState: MaintenanceState = { enabled: false };
export const defaultInitialMaintenanceTimeoutMs = 5000;

type GetMaintenanceStatusFn = (
  url: string,
  options?: GetMaintenanceStatusOptions,
) => Promise<MaintenanceState | undefined>;

export async function getInitialMaintenanceState(
  maintenanceUrl?: string,
  {
    timeoutMs = defaultInitialMaintenanceTimeoutMs,
    getMaintenanceStatusFn = getMaintenanceStatus,
  }: {
    timeoutMs?: number;
    getMaintenanceStatusFn?: GetMaintenanceStatusFn;
  } = {},
): Promise<MaintenanceState> {
  if (!maintenanceUrl) {
    return defaultInitialMaintenanceState;
  }

  const controller = new AbortController();
  const timeoutId = window.setTimeout(() => {
    controller.abort();
  }, timeoutMs);

  try {
    return (
      (await getMaintenanceStatusFn(maintenanceUrl, { signal: controller.signal })) ?? defaultInitialMaintenanceState
    );
  } finally {
    window.clearTimeout(timeoutId);
  }
}
